import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

import Cookies from "universal-cookie";

const cookie = new Cookies();
const token = cookie.get("token");

export const oncoApi = createApi({
  reducerPath: "reqres/onco",
  tagTypes: ["onco"],
  baseQuery: fetchBaseQuery({
    baseUrl: "https://oncomed.up.railway.app/",
    prepareHeaders: (headers, { getState }) => {
      // const token = getState().authSlice.token;
      if (token) {
        headers.set("Authorization", `Bearer ${token}`);
      }
      return headers;
    },
  }),
  endpoints: (build) => ({
    getArizaNotFinished: build.query({
      query: (page = 0) => `/oncomed/complaint?pageNumber=${page}`,
      providesTags: (result) =>
        result?.list && result?.list
          ? [
              ...result?.list?.map(({ id }) => ({
                type: "onco",
                id,
              })),
              { type: "onco", id: "LIST" },
            ]
          : [{ type: "onco", id: "LIST" }],
    }),
    getArizaFinished: build.query({
      query: (page = 0) => `oncomed/complaint/finished?pageNumber=${page}`,
      providesTags: (result) =>
        result?.list && result?.list
          ? [
              ...result?.list?.map(({ id }) => ({
                type: "onco",
                id,
              })),
              { type: "onco", id: "LIST" },
            ]
          : [{ type: "onco", id: "LIST" }],
    }),
    getAll: build.query({
      query: () => `oncomed/complaint/all?pageNumber=0`,
      providesTags: (result) =>
        result?.list && result?.list
          ? [
              ...result?.list?.map(({ id }) => ({
                type: "onco",
                id,
              })),
              { type: "onco", id: "LIST" },
            ]
          : [{ type: "onco", id: "LIST" }],
    }),

    check: build.mutation({
      query: (body) => ({
        url: `oncomed/complaint/client`,
        method: "POST",
        body,
      }),
      invalidatesTags: [{ type: "onco", id: "LIST" }],
    }),
    sendMsg: build.mutation({
      query: (body) => ({
        url: `oncomed/complaint`,
        method: "POST",
        body,
      }),
      invalidatesTags: [{ type: "onco", id: "LIST" }],
    }),
    finished: build.mutation({
      query: (body) => ({
        url: `oncomed/complaint/finished`,
        method: "PUT",
        body,
      }),
      invalidatesTags: [{ type: "onco", id: "LIST" }],
    }),
  }),
});

export const {
  useSendMsgMutation,
  useFinishedMutation,
  useGetArizaFinishedQuery,
  useGetArizaNotFinishedQuery,
  useGetAllQuery,
  useCheckMutation,
} = oncoApi;
